/**
 * Format a score to 2 decimal places with robust rounding
 * 
 * @param {number|string} score - The score to format
 * @returns {string} The formatted score as a string with 2 decimal places
 */
function formatScore(score) {
	const num = parseFloat(score);
	if (isNaN(num)) {
		return score; // Return original value if not a number (e.g., "Not Applicable")
	}
	// Use robust rounding before formatting
	return (Math.round(num * 100) / 100).toFixed(2);
}

